import { useState } from 'react';
import tw from 'twin.macro';
import { useTranslation } from 'react-i18next';

import { Button } from '@components/Button';
import { Loader } from '@components/Loader';
import { generateAIContentForEpisode } from '@services/index';
import { useEpisodeDetailsData } from '@insights_module/hooks/useEpisodeDetailsData';
import { useNotification } from '@insights_module/hooks/useNotification';

const GenAIButton = tw(
  Button.Primary
)`flex justify-center items-center min-h-[40px] px-[14px] disabled:bg-accent-muted disabled:cursor-not-allowed bg-accent-2 text-text-and-icon-invert border-none`;

const GENERATE_PROMOTION_TYPE_MAPPER = {
  twitter: 'twitter_post',
  facebook: 'facebook_post',
  linkedin: 'linkedin_post',
  instagram: 'instagram_post',
  show_notes: 'show_notes',
  summary: 'summary',
  article: 'article',
};

export const GenerateAIContentButton = () => {
  const { t } = useTranslation();
  const { notify, NTFC_TYPE } = useNotification();
  const {
    selectedPromotionItem,
    addEpisodeToEpisodesWithRecentlyGeneratedData,
    selectedPromotionItemIsGenerating,
  } = useEpisodeDetailsData();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleGenerateAIContent = () => {
    if (!selectedPromotionItem?.id) return;

    setIsLoading(true);

    generateAIContentForEpisode(selectedPromotionItem.id, {
      [GENERATE_PROMOTION_TYPE_MAPPER[selectedPromotionItem.type]]: true,
    })
      .then(() => {
        addEpisodeToEpisodesWithRecentlyGeneratedData(selectedPromotionItem.id, [
          selectedPromotionItem.type,
        ]);
      })
      .catch((error) => {
        notify({
          message: `${error.detail || 'Something went wrong'} | ${t(
            `insights.episode_details_drawer.promotion_view.${selectedPromotionItem?.type}.title`
          )}`,
          type: NTFC_TYPE.DANGER,
        });
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <GenAIButton onClick={handleGenerateAIContent} disabled={selectedPromotionItemIsGenerating}>
      {isLoading ? (
        <Loader
          tw='m-0 border-text-and-icon-invert! border-b-transparent!'
          size='sm'
          theme='dark'
        />
      ) : (
        t(
          `insights.episode_details_drawer.promotion_view.${selectedPromotionItem?.type}.generate_ai_button_title`
        )
      )}
    </GenAIButton>
  );
};
